var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2003 7.2C24.2003 11.1765 20.9767 14.4 17.0003 14.4C13.0238 14.4 9.80029 11.1765 9.80029 7.2C9.80029 3.22355 13.0238 0 17.0003 0C20.9767 0 24.2003 3.22355 24.2003 7.2ZM21.8003 7.2C21.8003 9.85097 19.6513 12 17.0003 12C14.3493 12 12.2003 9.85097 12.2003 7.2C12.2003 4.54903 14.3493 2.4 17.0003 2.4C19.6513 2.4 21.8003 4.54903 21.8003 7.2Z",
    fill: "#001C38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0003 18C9.23103 18 2.61142 22.5941 0.0898438 29.0305C0.704118 29.6404 1.35121 30.2174 2.02824 30.7585C3.90593 24.8492 9.79635 20.4 17.0003 20.4C24.2042 20.4 30.0947 24.8492 31.9724 30.7585C32.6494 30.2174 33.2965 29.6404 33.9108 29.0305C31.3892 22.5941 24.7696 18 17.0003 18Z",
    fill: "#001C38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAvatar);
export default __webpack_public_path__ + "static/media/ic_avatar.426b079295a18a0c5ac75c97b252ec21.svg";
export { ForwardRef as ReactComponent };